
export default class Event {
    startSelect;
    finishSelect;
    select;
    deselect;
}